/* eslint-disable import/no-cycle */
import rm from './rm';
import ho from './ho';
import mw from './mw';

const daftarTugas = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    rm,
    ho,
    mw,
  },
};
export default daftarTugas;
